import { useState } from 'react'
import { useCookies } from 'react-cookie'
import axios from 'axios'
import { api } from '../../common/api'
import { ACCESS_TOKEN } from '../../common/util' 

export type ClubDetailData = {
    snsUrl: string
    academyId: number
    academyAddress: string
    academyName: string
    memberCount: number
    contact: string
    academyCeoName: string
    academyCeoIdCardUrl: string
    academyCeoBankCopyUrl: string
    academyBusinessNumber: string
    academyBusinessCertificateName: string
    academyBusinessCertificateUrl: string
    academyLogoUrl: string
    academyCoachList?: [{
        coachLicenseImageUrl: string
        coachName: string
        coachPhoneNumber: string
    }]
    stadiumCount: number
    stadiumType: string
    largestStadiumWidth: number
    largestStadiumLength: number
    active: boolean
}

export default function useGetClubDetails() {
    const baseUrl = api.base_url
    const [cookies] = useCookies([ACCESS_TOKEN])
    const [academy, setAcademy] = useState<ClubDetailData>()
    const [clubDetailsError, setClubDetailsError] = useState('')

    const getClubDetails = async (clubId: string) => {
        try {
            const response = await axios(`${baseUrl}/academy/admin-detail/${clubId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${cookies[ACCESS_TOKEN]}`
                }
            })
            setAcademy(response.data.data)
        } catch (err) {
            console.error((err as Error).message)
            setClubDetailsError((err as Error).message)
        }
    }
    
    return { getClubDetails, academy, clubDetailsError }
}